export class productDB {
    static product = [
        {
            img: "assets/images/pro3/34.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        },
        {
            img: "assets/images/electronics/product/1.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        },
        {
            img: "assets/images/furniture/product/4.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"on sale",
            tag:"new"
        },
        {
            img: "assets/images/fashion/product/17.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        },
        {
            img: "assets/images/furniture/product/3.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        },
        {
            img: "assets/images/fashion/pro/1.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        },
        {
            img: "assets/images/furniture/product/10.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        },
        {
            img: "assets/images/goggles/product/4.jpg",
            product_title: "Slim Fit Cotton Shirt",
            discount: "$500.00",
            price: "$600.00",
            sale:"not on sale",
            tag:"old"
        }
    ]
}
